/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim & tidy whitespace`)
};

const es_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recorta y ordena espacios en blanco`)
};

const de_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerzeichen trimmen & aufräumen`)
};

const nl_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim en opruimen witruimte`)
};

const fr_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettoyer et organiser les espaces`)
};

const it_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglia e ordina gli spazi bianchi`)
};

const pt_br2_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparar e organizar espaços em branco`)
};

const pt_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apare e organize espaços em branco`)
};

const ja_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トリムとスペース整理`)
};

const zh_wsc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修剪并整理空白字符`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_nav_main_desc", locale)
	if (locale === "en") return en_wsc_nav_main_desc(inputs)
	if (locale === "es") return es_wsc_nav_main_desc(inputs)
	if (locale === "de") return de_wsc_nav_main_desc(inputs)
	if (locale === "nl") return nl_wsc_nav_main_desc(inputs)
	if (locale === "fr") return fr_wsc_nav_main_desc(inputs)
	if (locale === "it") return it_wsc_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_nav_main_desc(inputs)
	if (locale === "pt") return pt_wsc_nav_main_desc(inputs)
	if (locale === "ja") return ja_wsc_nav_main_desc(inputs)
	return zh_wsc_nav_main_desc(inputs)
};